<form id="dialPlanForm" [formGroup]="dialPlanFormGroup" class="grid mb-3">
  <div class="input-field col-12">
    <label>Nombre *</label>
    <input pInputText formControlName="name" class="w-full" />
  </div>
</form>

<app-dial-plan-flow
  *ngIf="!isNew"
  [rootActions]="rootActions"
  [dialPlanId]="dialPlan.id || ''">
</app-dial-plan-flow>

<div *ngIf="isNew" class="text-color-secondary text-center py-4">
  Guarda el plan para empezar a añadir acciones al flujo.
</div>

<div class="flex justify-content-end gap-2 mt-3">
  <p-button label="Cancelar" severity="secondary" (click)="cancel()"></p-button>
  <p-button label="Guardar" icon="pi pi-save" (click)="save()" [loading]="saving"></p-button>
</div>
